module.exports = __webpack_public_path__ + "img/colse_new.1d50fcc1.svg";